import React, { useState } from 'react';
import {
  useNotify,
  useRecordContext,
  useDelete,
  Button,
  Confirm,
  useRefresh,
} from 'react-admin';
import { Delete as DeleteIcon } from '@mui/icons-material';

export const DeleteWithPasswordButton: React.FC<{
  resource: string;
  redirect?: string | false;
  label?: string;
}> = ({ resource, redirect = 'list', label }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [deleteOne] = useDelete();

  if (!record) return null;

  const handleClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    setOpen(true);
  };

  const handleClose = (e?: any) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    if (!loading) setOpen(false);
  };

  const handleConfirm = async (e?: any) => {
    if (!password) return;
    e?.stopPropagation?.();
    e?.preventDefault?.();
    setLoading(true);
    try {
      await deleteOne(
        resource,
        { id: record.id, previousData: record, meta: { pass: password } },
        {
          onSuccess: () => {
            notify('Elemento eliminado', { type: 'info' });
            setOpen(false);
            refresh();
          },
          onError: (error: any) => {
            const message =
              error?.body?.message || error?.message || 'Error al eliminar';
            notify(message, { type: 'warning' });
          },
        }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        label={false}
        startIcon={<DeleteIcon />}
        color='error'
        onClick={handleClick}
        onMouseDown={e => e.stopPropagation()}
      />
      <Confirm
        isOpen={open}
        loading={loading}
        title={label || 'Confirmar eliminación'}
        content={
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <span>Introduce la contraseña para confirmar.</span>
            <input
              type='password'
              autoFocus
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{ padding: 6 }}
              placeholder='Contraseña'
            />
          </div>
        }
        onConfirm={handleConfirm}
        onClose={handleClose}
        confirmColor='warning'
      />
    </>
  );
};

export default DeleteWithPasswordButton;
